import _SwipeCell from './SwipeCell';
import './style';

export type { SwipeCellProps, SwipeCellRef } from './SwipeCell';
export * from './type';

export const SwipeCell = _SwipeCell;
export default SwipeCell;
